var CoiInputComponent, ReactCoiInputView, ReactComponent, View, mediator,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

CoiInputComponent = require('components/team/coi/coi_input');

mediator = require('mediator');

View = require('base/views/view');

ReactComponent = require('base/lib/traits/react_component');

module.exports = ReactCoiInputView = (function(_super) {
  __extends(ReactCoiInputView, _super);

  function ReactCoiInputView() {
    return ReactCoiInputView.__super__.constructor.apply(this, arguments);
  }

  ReactCoiInputView.prototype.className = 'coi-input-view';

  ReactCoiInputView.prototype.autoRender = true;

  ReactCoiInputView.prototype.initialize = function() {
    ReactCoiInputView.__super__.initialize.apply(this, arguments);
    this.enable(ReactComponent);
    return this.renderSimpleComponent(CoiInputComponent, {
      projectId: mediator.project.id,
      member: this.options.member,
      organizationId: mediator.project.get('organizationId'),
      onClose: this.dispose,
      coiFormType: this.options.coiFormType
    });
  };

  ReactCoiInputView.prototype.dispose = function() {
    if (this.disposed) {
      return;
    }
    this.unmountComponent();
    return ReactCoiInputView.__super__.dispose.apply(this, arguments);
  };

  return ReactCoiInputView;

})(View);
